import { render, staticRenderFns } from "./InstagramFilledIcon.vue?vue&type=template&id=4148ff4e&scoped=true"
var script = {}
import style0 from "./InstagramFilledIcon.vue?vue&type=style&index=0&id=4148ff4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148ff4e",
  null
  
)

export default component.exports